import { jsx as k, Fragment as V } from "react/jsx-runtime";
import { useContext as P, useCallback as O, createContext as Z, useRef as d, useState as E, useEffect as y, useMemo as J } from "react";
import { UserManager as ee, WebStorageStateStore as te } from "oidc-client-ts";
function re(e, r) {
  if (!e || e.expired || !e.profile.sub) return null;
  const t = e.profile, n = (u) => u == null || u === "" ? null : String(u);
  return JSON.stringify([
    r,
    t.iss ?? r,
    t.sub,
    n(t.distributor_id),
    n(t.client_id),
    t.is_platform_admin === !0 || t.is_platform_admin === "true"
  ]);
}
function fe() {
  const e = P(L);
  if (!(e != null && e.workspace)) throw new Error("Граница рабочего места требует AuthProvider");
  return e.workspace.key;
}
function pe() {
  const e = P(L), r = e == null ? void 0 : e.workspace;
  return O(() => () => !!(r != null && r.active), [r]);
}
const L = Z(null);
function ne(e, r) {
  const t = new te({ store: window.localStorage });
  return {
    authority: e.authority,
    client_id: e.client_id,
    redirect_uri: e.redirect_uri,
    post_logout_redirect_uri: e.post_logout_redirect_uri,
    response_type: "code",
    // Язык продукта не зависит от языка браузера владельца или клиента.
    extraQueryParams: { ui_locales: "ru" },
    scope: e.scope ?? "openid profile email",
    loadUserInfo: e.loadUserInfo ?? !1,
    automaticSilentRenew: e.automaticSilentRenew ?? !0,
    // Отмена сессии должна остановить не только событие userLoaded:
    // поздний refresh сначала записывает User, затем публикует событие.
    // PKCE state store не меняется. Истечение токена само по себе не terminal.
    userStore: {
      get: (n) => t.get(n),
      getAllKeys: () => t.getAllKeys(),
      remove: (n) => t.remove(n),
      set: (n, u) => r() ? Promise.reject(new Error("Запись завершённой сессии запрещена")) : t.set(n, u)
    }
  };
}
function me({ config: e, children: r, onSigninCallback: t }) {
  const n = d(!1), u = d(null);
  u.current === null && (u.current = new ee(ne(e, () => n.current)));
  const i = u.current, [m, S] = E(null), [g, b] = E(0), U = d(null), [w, Y] = E({ key: 0, identity: null, active: !1 }), I = d(w);
  y(() => (I.current.active = I.current.identity !== null, () => {
    I.current.active = !1;
  }), []);
  const _ = O((o) => {
    const c = re(o, e.authority), a = I.current;
    if (a.identity === c && a.active === (c !== null)) return;
    a.active = !1;
    const s = { key: a.key + 1, identity: c, active: c !== null };
    I.current = s, Y(s);
  }, [e.authority]), v = O((o) => {
    const c = (s) => Array.isArray(s) ? [...new Set(s.filter((h) => typeof h == "string"))].sort() : [], a = JSON.stringify([c(o == null ? void 0 : o.profile.roles), c(o == null ? void 0 : o.profile.permissions)]);
    U.current !== a && (U.current = a, b((s) => s + 1)), _(o), S(o);
  }, [_]), [B, q] = E(!0), [C, M] = E(void 0), [D, W] = E(!1), N = d(null), z = d(0), F = d(!1), A = d(!1), R = d([]), l = d(0), j = e.postCallbackUrl ?? "/";
  y(() => {
    let o = !1;
    const c = l.current;
    async function a() {
      try {
        if (window.location.pathname.endsWith("/auth/callback")) {
          N.current === null && (z.current = l.current, A.current = !0, N.current = i.signinCallback());
          const s = await N.current;
          if (o) return;
          if (!F.current) {
            F.current = !0, A.current = !1;
            const h = z.current === l.current, f = R.current.filter((p) => p !== s), Q = s && R.current.includes(s) && f.length === 0;
            if (R.current = [], !n.current && f.length) {
              const p = f[f.length - 1], X = l.current;
              await i.storeUser(p), !n.current && X === l.current && v(p);
            }
            if (!n.current && !f.length && (h || Q))
              s && (v(s), t == null || t(s)), window.location.pathname.endsWith("/auth/callback") && window.history.replaceState({}, document.title, j);
            else if (window.location.pathname.endsWith("/auth/callback")) {
              const p = new URL(window.location.href);
              p.searchParams.delete("code"), p.searchParams.delete("state"), window.history.replaceState({}, document.title, `${p.pathname}${p.search}${p.hash}`);
            }
          }
        } else {
          const s = await i.getUser();
          if (o || c !== l.current) return;
          s && !s.expired && v(s);
        }
      } catch (s) {
        if (o) return;
        const h = R.current.at(-1);
        A.current = !1, R.current = [], !o && !n.current && h && v(h), !o && c === l.current && M(s instanceof Error ? s : new Error(String(s)));
      } finally {
        o || q(!1);
      }
    }
    return a(), () => {
      o = !0;
    };
  }, [i, t, j, v]), y(() => {
    const o = (f) => {
      if (l.current++, !n.current) {
        if (A.current) {
          R.current.push(f);
          return;
        }
        v(f);
      }
    }, c = () => {
      l.current++, n.current = !0, v(null);
    }, a = () => {
      c(), i.storeUser(null).catch(() => {
      });
    }, s = () => {
      l.current++, _(null);
    }, h = (f) => M(f);
    return i.events.addUserLoaded(o), i.events.addUserUnloaded(c), i.events.addUserSignedOut(a), i.events.addSilentRenewError(h), i.events.addAccessTokenExpired(s), () => {
      i.events.removeUserLoaded(o), i.events.removeUserUnloaded(c), i.events.removeUserSignedOut(a), i.events.removeSilentRenewError(h), i.events.removeAccessTokenExpired(s);
    };
  }, [i, v, _]);
  const H = O(async () => {
    await i.signinRedirect();
  }, [i]), K = O(async () => {
    W(!0), n.current = !0, l.current++, _(null);
    try {
      await i.signoutRedirect();
    } catch (o) {
      throw W(!1), await i.storeUser(null).catch(() => {
      }), o;
    }
  }, [i, _]), x = J(
    () => ({
      user: m,
      workspace: w,
      authorizationVersion: g,
      isAuthenticated: !D && w.active && !!m && !(m != null && m.expired),
      isLoading: B,
      isSigningOut: D,
      error: C,
      login: H,
      logout: K,
      userManager: i
    }),
    [m, w, g, B, D, C, H, K, i]
  );
  return /* @__PURE__ */ k(L.Provider, { value: x, children: r });
}
function T() {
  const e = P(L);
  if (!e)
    throw new Error("useAuth must be used within an <AuthProvider>");
  return e;
}
function he() {
  const { user: e, isAuthenticated: r, isSigningOut: t } = T();
  return r && !t ? (e == null ? void 0 : e.access_token) ?? null : null;
}
function $(e) {
  if (typeof e == "number") return e;
  if (typeof e == "string" && e.trim() !== "") {
    const r = Number(e);
    return Number.isFinite(r) ? r : null;
  }
  return null;
}
function ie(e) {
  return typeof e == "boolean" ? e : typeof e == "string" ? e.toLowerCase() === "true" : !1;
}
function G(e) {
  return Array.isArray(e) ? e.filter((r) => typeof r == "string") : [];
}
function ge() {
  const { user: e, authorizationVersion: r } = T();
  return J(() => {
    if (!e) return null;
    const t = e.profile;
    return {
      ...r === void 0 ? {} : { authorizationVersion: r },
      userId: typeof t.sub == "string" ? t.sub : "",
      username: typeof t.preferred_username == "string" ? t.preferred_username : typeof t.email == "string" ? t.email : "",
      email: typeof t.email == "string" ? t.email : void 0,
      distributorId: $(t.distributor_id),
      clientId: $(t.client_id),
      isPlatformAdmin: ie(t.is_platform_admin),
      permissions: G(t.permissions),
      roles: G(t.roles)
    };
  }, [e, r]);
}
function ve({ children: e, loadingFallback: r }) {
  const { isAuthenticated: t, isLoading: n, isSigningOut: u, login: i } = T();
  return y(() => {
    !n && !t && !u && i();
  }, [n, t, u, i]), n || !t ? /* @__PURE__ */ k(V, { children: r ?? /* @__PURE__ */ k(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      style: {
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--color-text-secondary)",
        fontSize: 13
      },
      children: "Проверяем сессию…"
    }
  ) }) : /* @__PURE__ */ k(V, { children: e });
}
function we({
  onSessionExpired: e,
  onAccessTokenExpiring: r,
  onSessionRestored: t
}) {
  const { userManager: n, user: u, isAuthenticated: i, isSigningOut: m } = T(), S = d(t);
  return y(() => {
    S.current = t;
  }, [t]), y(() => {
    var g;
    u && i && !m && ((g = S.current) == null || g.call(S));
  }, [u, i, m]), y(() => {
    const g = () => e("expired"), b = () => e("signed_out"), U = () => e("silent_renew_error"), w = () => r == null ? void 0 : r();
    return n.events.addAccessTokenExpired(g), n.events.addUserSignedOut(b), n.events.addSilentRenewError(U), r && n.events.addAccessTokenExpiring(w), () => {
      n.events.removeAccessTokenExpired(g), n.events.removeUserSignedOut(b), n.events.removeSilentRenewError(U), r && n.events.removeAccessTokenExpiring(w);
    };
  }, [n, e, r]), null;
}
const se = ["CLIENT_OWNER", "CLIENT_EMPLOYEE"], oe = [
  "DISTRIBUTOR_OWNER",
  "DISTRIBUTOR_ADMIN",
  "DISTRIBUTOR_MANAGER",
  "DISTRIBUTOR_FIELD_EMPLOYEE"
], ue = new Set(se), ce = new Set(oe);
function ye(e) {
  return !!(e != null && e.some((r) => ue.has(r)));
}
function Se(e) {
  return !!(e != null && e.some((r) => ce.has(r)));
}
export {
  L as AuthContext,
  me as AuthProvider,
  se as CLIENT_SIDE_ROLES,
  oe as DISTRIBUTOR_SIDE_ROLES,
  ve as RequireAuth,
  we as SessionExpiredHandler,
  ye as isClientSideUser,
  Se as isDistributorSideUser,
  he as useAccessToken,
  T as useAuth,
  pe as useAuthOperationGuard,
  fe as useAuthWorkspaceKey,
  ge as useDistributionPrincipal
};
//# sourceMappingURL=index.js.map
